import './right-panel-bronze.scss';
import React from 'react';
import { observer } from 'mobx-react-lite';
import RightPanelStatic from '@svg/right-panel-bronzes.svg?react';
import CustomButton from '../shared/custom-button/custom-button';
import { useStores } from '../store';

export const RightPanelBronze: React.FC = observer(() => {
    const { customerStore } = useStores();

    return <div className="right-panel">
        <div className="right-panel-header">
            <div className="title">{'Ready for next level \ncyber security?'}</div>
            <div className="sub-title">{'Upgrade your account to get advanced \nfeatures and level-up your business’ security'}</div>
        </div>
        <div className="svg-wrapper">
            <RightPanelStatic />
        </div>
        <div className="learn-more-button-wrapper">
            <CustomButton className={'custom-btn primary-btn learn-more-button'} label="Learn More"
                onClick={() => window.open(`/plan-upgrade-${customerStore.selectedLocation?.serviceLevel.toLocaleLowerCase()}`, '_blank')} />
        </div>
    </div>;
});